import BossModel from "@/models/BossModel";
import File from "@/models/File/File";

export default class ManualDownload extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/manual-download';

    /**
     *
     * @type {string}
     */
    static entity = 'manualDownloads';

    static fields() {
		return {
			id: this.attr(null),
			file_id: this.attr(null),
			dossier_id: this.attr(null),
			name: this.attr(null),
			is_active: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            file: this.belongsTo(File, 'file_id'),
		}
	}

    /**
     *
     * @param input
     * @returns {Promise<AxiosResponse<T>>}
     */
    static createWithFile(input){
        return this.api().action('create-with-file').create({
            name: input.name,
            file: input.file,
            dossier_id: input.dossier_id,
            is_active: 1,
        }, false).then(response => {
            File.insert(response.file);
            this.insert(response.manualDownload);
        });
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId) {
        return this.api().with(['file'])
            .where('dossier_id', dossierId)
            .limit(0)
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     */
    File(){
        return this.getRelated('file');
    }
}
